import styled from 'styled-components';

import { Modal } from '@dexma/ui-components';

type WrapperProps = {
    hasSaveAndProceedButton: boolean;
};

export const StyledConfirmActionModal = styled(Modal)<WrapperProps>`
    white-space: pre-line;
    .buttons {
        margin-top: 30px;
        text-align: right;
        display: flex;
        justify-content: ${({ hasSaveAndProceedButton }) => (hasSaveAndProceedButton ? 'space-between' : 'flex-end')};
        button {
            margin: ${({ hasSaveAndProceedButton }) => (hasSaveAndProceedButton ? '0px' : '0 5px 0 5px')};
        }
        .cancel {
            margin-left: 10px;
        }
        // Todo fix on the ui library
        svg,
        .StyledSpinner-iA-dccK {
            border-color: rgb(255 255 255) rgba(255, 255, 255, 0.1) rgba(255, 255, 255, 0.1);
            margin-right: 5px;
        }
    }
    p {
        margin: 0;
    }
    top: calc(50% - 220px);

    .ant-modal-header {
        border-bottom: none;
    }
`;
